module.exports = __webpack_public_path__ + "img/disease-course-and-impact-carousel-1-image.997cdd0e.png";